import React, { FC, HTMLAttributes } from 'react';

import styles from './MapIcon.module.scss';

type Props = HTMLAttributes<HTMLElement> & {};

export const MapIcon: FC<Props> = ({ ...props }) => (
  <i {...props} className={`${styles['map-icon']} ${props.className}`} />
);
